import LoadingButton from "@mui/lab/LoadingButton";
import { Typography } from "@mui/material"
import React, { Fragment, useEffect, useState } from "react"

export const GenericResendVerificationForm = ({ email, resend, loadingSend }) => {

  const [resendSeconds, setResendSeconds] = useState(30);

  useEffect(() => {
    if (resendSeconds > 0) {
      const interval = setInterval(() => {
        setResendSeconds((prevSeconds) => prevSeconds - 1);
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [resendSeconds]);

  const handleResend = () => {
    resend();
    setResendSeconds(30);
  };

  return (
    <Fragment>
      <Typography fontSize={'16px'} textAlign={'center'}>
        You’re almost there! We sent a verification link to <br></br><strong>{email}</strong>
      </Typography>
      <Typography textAlign={'center'}>Not in inbox or spam folder?</Typography>
      <LoadingButton loading={loadingSend} variant="contained" sx={{ color: "#FFF", width: { md: '250px' } }} disabled={resendSeconds > 0} fullWidth onClick={handleResend}>
        Resend Email {resendSeconds > 0 && `(${resendSeconds})`}
      </LoadingButton>
    </Fragment>
  );
};